var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEconomFuel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_11078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.285 13.4628C39.0161 15.5051 39.4137 17.7063 39.4137 19.9998C39.4137 30.7215 30.7225 39.4127 20.0008 39.4127C9.27908 39.4127 0.587891 30.7215 0.587891 19.9998C0.587891 9.27811 9.27908 0.586914 20.0008 0.586914C22.2943 0.586914 24.4955 0.984566 26.5378 1.71568",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 21.9569C21.0807 21.9569 21.9569 21.0807 21.9569 19.9999C21.9569 18.9191 21.0807 18.043 19.9999 18.043C18.9191 18.043 18.043 18.9191 18.043 19.9999C18.043 21.0807 18.9191 21.9569 19.9999 21.9569Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16268 24.6966H4.03156V19.9999H7.16268M4.03156 22.3483H7.16268M33.9337 25.3228V19.9999H37.0648M33.9337 22.3483H36.282M15.9298 27.9843H18.9044M26.8104 31.2719L24.4621 30.4892V28.1408H26.8104M26.8104 31.2719V28.1408M26.8104 31.2719V34.7944C26.8104 35.5294 26.2147 36.1252 25.4797 36.1252C24.7447 36.1252 24.149 35.5294 24.149 34.7944C24.149 34.0595 23.5532 33.4637 22.8183 33.4637H20.5482M26.8104 28.1408V26.0273L25.1666 25.088M20.0002 2.54395V6.45784M10.2371 15.9559L18.1923 19.251M13.3202 3.87271L14.8179 7.48868M7.657 7.65667L10.4246 10.4243M3.87305 13.3198L7.48902 14.8176M20.5482 36.1252H14.286V26.8101C14.286 26.1616 14.8117 25.6359 15.4601 25.6359H19.374C20.0225 25.6359 20.5482 26.1616 20.5482 26.8101V36.1252Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8039 17.808C35.5594 17.808 39.4145 13.953 39.4145 9.19748C39.4145 4.442 35.5594 0.586914 30.8039 0.586914C26.0484 0.586914 22.1934 4.442 22.1934 9.19748C22.1934 13.953 26.0484 17.808 30.8039 17.808Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8038 9.90213C29.9392 9.90213 29.2383 9.20123 29.2383 8.33657V4.57923C29.2383 3.71457 29.9392 3.01367 30.8038 3.01367C31.6685 3.01367 32.3694 3.71457 32.3694 4.57923V8.33657C32.3694 9.20123 31.6685 9.90213 30.8038 9.90213Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8038 15.3816C31.6685 15.3816 32.3694 14.6807 32.3694 13.816C32.3694 12.9514 31.6685 12.2505 30.8038 12.2505C29.9392 12.2505 29.2383 12.9514 29.2383 13.816C29.2383 14.6807 29.9392 15.3816 30.8038 15.3816Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_11078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomFuel);
export default __webpack_public_path__ + "static/media/EconomFuel.c95f955112c6154065140ad3f057b4ec.svg";
export { ForwardRef as ReactComponent };